export default {
  /** 问卷数据  **/
  surveyList: `/survey/app/survey/list`,
  surveyInfo: `/survey/app/survey/info`,
  surveyUpdate: `/survey/app/survey/survey-base-attr`,
  surveyCreate: `/survey/app/survey/add`,
  surveyUpState: `/survey/app/survey/up-survey-status`,
  surveyCopy: `/survey/app/survey/copy`,
  surveyDelete: `/survey/app/survey/delete`,
  surveyReport: `/survey/app/stats/report`,
  surveyAnswerList: `/survey/app/answer/list`,
  surveyAnswerInfo: `/survey/app/answer/info`,
  surveyAnswerExport: `/survey/app/answer/export-xls`,
  surveyAnswerDelete: `/survey/app/answer/delete`,
  surveyAnswerExportList: `/survey/export/management/list`,
  surveyAnswerExportDelete: `/survey/export/management/delete`,
  surveyAnswerUnSubmit: `/survey/app/answer/unSubmitList`,
  surveyFooterInfo: `/survey/anon/web/footer-info`,
  adminUserList: `/survey/admin/user/list`,
  adminUserCreate: `/survey/admin/user/add`,
  adminUserUpdate: `/survey/admin/user/edit`,
  adminUserDelete: `/survey/admin/user/delete`,
  curUserInfo: `/survey/app/user/currentUser`,
  curUserPwdUpdate: `/survey/app/user/up-pwd`,
  dwSurveyUnSubmitExport: `/survey/app/answer/export-unSubmitxls`

}



// WEBPACK FOOTER //
// ./src/api/index.js